<template>
  <header>
  </header>
</template>
<script>
export default {
  name: "HeaderElem",
};
</script>